// extracted by mini-css-extract-plugin
export default {"overlay":"config__overlay___ukfeX","controlRow":"config__controlRow___e1lUU","sectionStart":"config__sectionStart___SUYhl","controlLabel":"config__controlLabel___dlxIm"};